import { render, staticRenderFns } from "./addComment.vue?vue&type=template&id=338cfa94&scoped=true"
import script from "./addComment.vue?vue&type=script&lang=js"
export * from "./addComment.vue?vue&type=script&lang=js"
import style0 from "./addComment.vue?vue&type=style&index=0&id=338cfa94&prod&lang=css"
import style1 from "./addComment.vue?vue&type=style&index=1&id=338cfa94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338cfa94",
  null
  
)

export default component.exports